import { CtControlConfiguration, CtControlTypes, CtSearchFilterControlConfiguration, CtSelectControlValue, CtThemeTypes } from "@ctsolution/ct-framework";
import { AddressBookTypeEnum, AddressBookTypeLabelMapping } from "../interfaces/address-book-response";
import { NameFilter } from "./group-list.parameter";

export class AddressBookListParameter {

    Type: AddressBookTypeEnum | null = null;

    private constructor() {
    }

    public static create = (): AddressBookListParameter => new AddressBookListParameter();

    setType(value: AddressBookTypeEnum | null) {

        this.Type = value;
        return this;

    }

}


export const AddressBookTypes = Object
  .values(AddressBookTypeEnum)
  .filter((v): v is AddressBookTypeEnum => typeof v === 'number');

const AddressBookTypeValueOptions = (): CtSelectControlValue[] => {

  const values: CtSelectControlValue[] = [];

  AddressBookTypes
    .forEach(type => {

      values
        .push(
          CtSelectControlValue
            .create()
            .setLabel(AddressBookTypeLabelMapping[type])
            .setValue(type));

    });

  return values;

};

const AddressBookTypeFilter: CtSearchFilterControlConfiguration =
  CtSearchFilterControlConfiguration
    .create("Type")
    .setLabel("Tipologia")
    .setCTControlConfiguration(
      CtControlConfiguration
        .create({
          name: "Type",
          label: "Tipologia",
          type: CtControlTypes.ENUMERABLE,
          theme: CtThemeTypes.MATERIAL,
          materialOptions: { appearance: "legacy" }
        } as CtControlConfiguration)
        .setValueOptions(AddressBookTypeValueOptions()));


export const AddressBookListFilters: CtSearchFilterControlConfiguration[] = [NameFilter,AddressBookTypeFilter];